import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import Info from '../../../Tools/Info';

const TikTokSettings = React.memo(({ formData, handleInputChange, toggleDisclosure, toggleBranded, userSocials }) => (
  <div className='flex flex-col py-3 --theme-colors rounded-lg px-2'>
    <div className='flex justify-between'>
      <p className='font-semibold mr-3'>Allow users to:</p>
      <div className='group'>
        <Info type="tiktokFeatures" />
      </div>
    </div>

    {userSocials && userSocials.map((item, index) => (
      item.platform === 'tiktok' && (
        <div className='flex space-x-3' key={index}>
          <label className='' key="comment-label">
            <input
              type="checkbox"
              className="medium-checkbox"
              checked={formData.commentEnabled}
              onChange={(e) => handleInputChange('commentEnabled', e.target.checked)}
            />
            Comment
          </label>
          <br />
          <label className={`relative group`} key="duet-label">
            <input
              type="checkbox"
              className="medium-checkbox"
              checked={formData.duetEnabled}
              onChange={(e) => handleInputChange('duetEnabled', e.target.checked)}
            />
            Duet
          </label>
          <br />
          <label className={`relative group`} key="stitch-label">
            <input
              type="checkbox"
              className="medium-checkbox item"
              checked={formData.stitchEnabled}
              onChange={(e) => handleInputChange('stitchEnabled', e.target.checked)}
            />
            <span>Stitch</span>
          </label>
        </div>
      )
    ))}

    <div className='flex flex-col mt-5'>
      <div className='flex relative'>
        <p className='flex-1 font-semibold'>Disclose video content:</p>
        <label className="switch relative">
          <input type="checkbox" onChange={toggleDisclosure} checked={formData.isContentDisclosed} className="sr-only" />
          <div className={`w-12 h-6 rounded-full shadow-md bg-gray-400 ${formData.isContentDisclosed && 'bg-green-500'}`}>
            <div
              className={`indicator w-6 h-6 rounded-full bg-white transform ${formData.isContentDisclosed ? 'translate-x-full' : 'translate-x-0'} transition duration-300 ease-in-out`}
            ></div>
          </div>
        </label>
      </div>
      <div>
        <p className='text-[10px]'>Turn on to disclose that this video promotes goods or services.</p>
      </div>
      {formData.isContentDisclosed && (
        <DisclosureSettings
          formData={formData}
          handleInputChange={handleInputChange}
          toggleBranded={toggleBranded}
        />
      )}
    </div>
  </div>
));

const DisclosureSettings = React.memo(({ formData, handleInputChange, toggleBranded }) => (
  <div className='flex flex-col transition duration-300'>
    <div className='flex bg-blue-300 p-2 m-2 rounded-lg text-[12px]'>
      <FaInfoCircle size={20} className='mr-2' />
      <span>Your video will be labeled <span className='underline font-semibold'>Promotional Content</span>. This cannot be changed once your video is posted!</span>
    </div>
    <div className='flex-col w-[80%] mx-auto'>
      <label className="flex">
        <span className='flex-1 font-semibold'>Your Brand</span>
        <input type="checkbox" className="medium-checkbox" onChange={(e) => handleInputChange('isOwnBrand', e.target.checked)} checked={formData.isOwnBrand} />
      </label>
      <p className='text-[12px]'>You are promoting yourself or your own business/brand. This video will be classified as <span className='font-semibold underline'>Brand Organic</span></p>
    </div>
    <div className='flex-col w-[80%] mx-auto my-3'>
      <label className="flex">
        <span className='flex-1 font-semibold'>Branded Content</span>
        <input type="checkbox" className="medium-checkbox" onChange={toggleBranded} checked={formData.isBranded} />
      </label>
      <p className='text-[12px]'>You are promoting another brand or a third party. This video will be classified as <span className='font-semibold underline'>Branded Content</span>. <span className='text-red-300 underline'>Privacy setting will be set to public!</span></p>
    </div>
    <div>
      <p className='text-[10px]'>* Your photo/video will be labeled as <span className='font-semibold underline'>Paid Partnership</span></p>
    </div>
  </div>
));

export default TikTokSettings; 